module.exports = __webpack_public_path__ + "static/media/doc-editor.bed0cd44.png";